import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { DesksTurnsService } from 'src/app/services/turns-services/desks-turns-service/desks-turns.service';
import { Subscription } from 'rxjs';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { Location } from 'src/app/models/turns-models/location.model';

@Component({
  selector: 'app-turns-desk-locations-card',
  templateUrl: './turns-desk-locations-card.component.html',
  styleUrls: ['./turns-desk-locations-card.component.scss']
})
export class TurnsDeskLocationsCardComponent implements OnInit, OnDestroy {

  @Input() internalId;
  @Input() locations: Array<Location>;
  @Input() assignedLocations: Array<Location>;
  locationsInternalIdSubscription: Subscription;

  constructor(private desksTurnsService: DesksTurnsService,
              private userStorageService: UserStorageService,
            private snackbarService: SnackBarService) { }

  ngOnInit() {
  }

  public outputEventReceiver(selectedLocations)  {
    const locationsInternalId = new Array();
    for (const d of selectedLocations) {
      locationsInternalId.push(d[1]._data);
    }
    this.locationsInternalIdSubscription = this.desksTurnsService.saveDeskLocations(this.internalId, locationsInternalId).subscribe(
      (res) => {
        this.snackbarService.open('turns-page.snackbar messages.update desk success', 'success');
      },
      (error) => {
        this.desksTurnsService.refreshDesk();
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  ngOnDestroy() {
    if (this.locationsInternalIdSubscription) { this.locationsInternalIdSubscription.unsubscribe(); }
  }

}
